import { render, staticRenderFns } from "./Fan.vue?vue&type=template&id=abfaf2b2&scoped=true&"
import script from "./Fan.vue?vue&type=script&lang=js&"
export * from "./Fan.vue?vue&type=script&lang=js&"
import style0 from "./Fan.vue?vue&type=style&index=0&id=abfaf2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfaf2b2",
  null
  
)

export default component.exports